import Checkbox from "rc-checkbox";
import "rc-checkbox/assets/index.css";
import styles from "src/features/Event/components/IncludeCompletedEventToggleButton/includeCompletedEventToggleButton.module.css";
import { useAtom, useSetAtom } from "jotai";
import { useEffect, useRef } from "react";
import {
    isFilteredOfCompletedEventsAtom,
    topPageEventListObjectAtom,
} from "../../event.atom";

type IncludeCompletedEventToggleButtonProps = {};

const IncludeCompletedEventToggleButton: React.FC<
    IncludeCompletedEventToggleButtonProps
> = () => {
    const isFirstRender = useRef(true);

    const [isFilteredOfCompletedEvents, toggleIsFilteredOfCompletedEvents] =
        useAtom(isFilteredOfCompletedEventsAtom);

    const setTopPageEventListObject = useSetAtom(topPageEventListObjectAtom);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setTopPageEventListObject(true);
    }, [setTopPageEventListObject, isFilteredOfCompletedEvents]);

    return (
        <div className={styles.container}>
            <Checkbox
                id="price-checkbox"
                onChange={() => {
                    toggleIsFilteredOfCompletedEvents();
                }}
                checked={isFilteredOfCompletedEvents}
            />
            <p> 終了したイベントも含める</p>
        </div>
    );
};

export default IncludeCompletedEventToggleButton;
